export const initialDataExportsData = {
    data: [],
    isFetching: {loadingPageData: false},
    dropDownList: {suggestionDropdown: false},
    popupList: {},
    currentExport: {},
    successMessages: {
        message: "",
        messageTheme: '',
        duration: 0,
        from: ""
    },
    totalPages: 0,
    currentPage: 1,
    totalCount: 0,
}
const DataExportReducer = (state, action) => {
    switch(action.type){
        case "SET_STATE": {
            return {
                ...state,
                ...action.payload
            }
        }
        default: return state;
    }
}
export const ALL_ACTIONS = {
    SET_STATE: "SET_STATE"
}
export default DataExportReducer